import React from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'

export function Layout() {
  const { pathname } = useLocation()
  const tabs = [
    { to: `/`, label: 'Home', end: true },
    { to: `/connectors`, label: 'Connectors' },
    { to: `/issues`, label: 'Issues' },
    { to: `/imports`, label: 'Imports' },
    { to: `/audit`, label: 'Audit' },
    { to: `/oauth-clients`, label: 'OAuth Clients' },
    { to: `/queue`, label: 'Queue' },
  ]

  return (
    <div className="min-h-screen">
      <header className="border-b bg-background">
        <div className="container flex min-h-14 flex-wrap items-center justify-between gap-3 py-3">
          <Link to="/" className="shrink-0 font-semibold">Email Sync Admin</Link>
          <nav aria-label="Main navigation" className="flex flex-wrap items-center gap-x-4 gap-y-3 text-sm">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end as any}
                className={({ isActive }) =>
                  `transition-colors hover:text-foreground ${
                    isActive
                      ? 'text-foreground'
                      : 'text-muted-foreground'
                  }`
                }
              >
                {t.label}
              </NavLink>
            ))}
            <form method="post" action="/logout">
              <button className="rounded-md bg-secondary px-3 py-1.5 text-xs text-secondary-foreground hover:opacity-90" title="Kilépés">Logout</button>
            </form>
          </nav>
        </div>
      </header>
      <main className="container py-6">
        <Outlet />
      </main>
    </div>
  )
}
